import React from "react";
import "./App.css";
import logo from "./assets/logo.png";
import cake1 from "./assets/cake1.png";
import cake2 from "./assets/cake2.png";
import cake3 from "./assets/cake3.png";
import cake4 from "./assets/cake4.png";
import cake5 from "./assets/cake5.png";
import cake6 from "./assets/cake6.png";
import cake7 from "./assets/cake7.png";
import cake8 from "./assets/cake8.png";
import cake9 from "./assets/cake9.png";
import cake10 from "./assets/cake10.png";
import cake11 from "./assets/cake11.png";
import cake12 from "./assets/cake12.png";
import cake13 from "./assets/cake13.png";
import { isMobile } from "react-device-detect";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

// import styles bundle
import "swiper/css";
import "swiper/css/pagination";

// https://coolors.co/palette/e27396-ea9ab2-efcfe3-eaf2d7-b3dee2

const App = () => {
  return (
    <div>
      <header>
        <div class="d-flex overflow-hidden me-4 text-center">
          <div
            class={`${
              isMobile ? "col-12" : "col-6"
            } mx-auto my-5 gap-5 d-flex flex-column`}
          >
            <img class="fw-bold very-berry img-fluid me-2" src={logo} />
            <div class={`container-lg ${isMobile ? "pt-2" : "pt-5"}`}>
              <h1
                class={`logo-text-color display-3 fw-bold very-berry ${
                  isMobile ? "ms-5" : "ms-5 ps-5"
                }`}
              >
                When moments become memories
              </h1>
            </div>
          </div>
        </div>
      </header>
      <main className="main-bg">
        <div class="d-flex justify-content-center gap-5 flex-row container-md text-center mt-5 mb-5">
          <a
            target="_blank"
            rel="noopener noreferrer"
            class="btn social-button-link"
            href="https://www.instagram.com/sevenlyweddingcakes"
            aria-label="Instagram link"
            role="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={isMobile ? "70" : "100"}
              height={isMobile ? "70" : "100"}
              viewBox="0 0 16 16"
              fill="#5a8cae"
              class="bi bi-instagram"
            >
              <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598 2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334" />
            </svg>
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            class="btn social-button-link"
            href="https://www.facebook.com/profile.php?id=100063716894083"
            aria-label="Facebook link"
            role="button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={isMobile ? "70" : "100"}
              height={isMobile ? "70" : "100"}
              viewBox="0 0 16 16"
              fill="#5a8cae"
              class="bi bi-facebook"
            >
              <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951" />
            </svg>
          </a>
        </div>

        <div class="container-md">
          <hr />
        </div>

        <div class="container-md text-center mt-5 mb-5">
          <h2 class="display-5">About me</h2>
          <h3 class="display-6 very-berry mt-4 mb-3">
            A story of love, memory & wedding cakes
          </h3>
          <p class="fs-2 fw-light">
            Hello, I'm Denise, and every cake I make is inspired by my mums
            legacy of love. My love of cake decorating was born after I made my
            youngest child's birthday cake. It quickly became my favourite past
            time. Creating beautiful wedding cakes is not just my profession,
            it's my passion. I specialise in crafting cakes that reflect each
            couples unique love story.
          </p>
        </div>

        <div class="container-md text-center mt-5 mb-5">
          <h2 class="display-5">Contact me</h2>
          <h3 class="ms-2 text-wrap">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              class="bi bi-envelope me-2"
              viewBox="0 0 16 16"
            >
              <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z" />
            </svg>
            <span class="fs-2 fw-light">denise@sevenlyweddingcakes.com</span>
          </h3>
          <h3 class="me-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              fill="currentColor"
              class="bi bi-telephone me-2"
              viewBox="0 0 16 16"
            >
              <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z" />
            </svg>
            <span class="fs-2 fw-light ">07779056846</span>
          </h3>
        </div>

        <div class="container-md">
          <hr />
        </div>

        <div class="container-md text-center mt-5 mb-5">
          <h2 class="display-5">How to order/enquire</h2>
          <p class="fs-2 fw-light">
            Every wedding cake is carefully crafted to your precise
            requirements. If you're planning your big day, please reach out and
            we can work together to create something special.
            <br />
            Click the enquire button below
          </p>

          <a
            role="button"
            class="btn btn-outline-primary btn-lg logo-text-color logo-bg-color"
            target="_blank"
            rel="noopener noreferrer"
            href="https://forms.gle/1TiKwSiB7tczN6rs8"
          >
            Enquire
          </a>
        </div>

        <div class="container-md">
          <hr />
        </div>

        <div class="container-lg mt-5 mb-5">
          <Swiper
            pagination={true}
            modules={[Pagination]}
            class="w-100"
            grabCursor
            loop
            parallax
            autoplay={{ delay: 1000 }}
            slidesPerView={!isMobile ? 3 : undefined}
            spaceBetween={!isMobile ? 300 : undefined}
            grid={isMobile ? { rows: 3 } : undefined}
          >
            <SwiperSlide>
              <img src={cake10} class="d-block carousel-img" alt="Cake 1" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={cake9} class="d-block carousel-img" alt="Cake 2" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={cake13} class="d-block carousel-img" alt="Cake 3" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={cake3} class="d-block carousel-img" alt="Cake 4" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={cake1} class="d-block carousel-img" alt="Cake 5" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={cake2} class="d-block carousel-img" alt="Cake 6" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={cake4} class="d-block carousel-img" alt="Cake 7" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={cake11} class="d-block carousel-img" alt="Cake 8" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={cake5} class="d-block carousel-img" alt="Cake 9" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={cake6} class="d-block carousel-img" alt="Cake 10" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={cake12} class="d-block carousel-img" alt="Cake 11" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={cake7} class="d-block carousel-img" alt="Cake 12" />
            </SwiperSlide>
            <SwiperSlide>
              <img src={cake8} class="d-block carousel-img" alt="Cake 13" />
            </SwiperSlide>
          </Swiper>
        </div>
      </main>
    </div>
  );
};

export default App;
